import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ContentData } from 'components/cases/common/Interview/fragments/type'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
gsap.registerPlugin(ScrollTrigger)

const contentData: ContentData[][] = [
  [
    {
      type: 'sectionTitle',
      text: 'デザインだけではないアイスリーデザインの魅力',
    },

    {
      type: 'greyBox',
      texts: [
        '今回のプロジェクトは既存のサービスを大刷新するという内容で、その根幹となる新たなコンセプト作りから依頼したいと考えていました。そこで、保険や金融関連企業のプロジェクトに対して、豊富な実績をお持ちのアイスリーさんにコンタクトを取らせていただきました。',
        '実際にお話を伺っていく中で、アイスリーさんはデザインだけでなくコーディングなどの開発体制もお持ちだと知り、より精度の高いお仕事が期待できると考えて依頼することにいたしました。',
        '他の企業は、デザインを作って終了といったところが多かったので、デザインと開発を一気通貫で行えるアイスリーさんの体制は非常に魅力的だと感じられました。',
      ],
    },
    {
      type: 'sectionTitle',
      text: '目的に紐づく、あらゆる課題が違う視点から見つけられた',
    },

    {
      type: 'greyBox',
      texts: [
        'まず印象的だったのは、弊会の本プロジェクトに関わるメンバー全員を巻き込んで「デザインスプリント」というワークショップを行ったことです。',
        'そこからユーザーインタビューやプロトタイプを作ってのテストへ進んでいったのですが、このプロセスを経ることで社内のコミュニケーションが円滑となり、弊会としても良い財産となる経験を積めたと考えています。開発自体は大規模なものだったため、2018年はじめにプロジェクトをスタートし、2021年6月にかけて段階的にローンチしていく形を採用しました。',
        'アイスリーさんにはそのあらゆる段階において、弊会が抱える課題に対して具体的な解決方法を一緒に考えていただくことができ、とても心強く感じました。更に“作って終わり”ではなく、運用フェーズに入ってからもデザインのご提案をいただいたり、弊社からの相談に乗っていただいたり、親身に対応をしていただきました。アイスリーさんにユーザーインタビューやリサーチをしていただく中で、サイト設計以外の広報戦略に対する課題も発見することができたなど、手厚いサポート体制もありがたいです。その甲斐もあって、共済推進を担う地域生協との協力体制の充実などを通じて、サイトの認知を大きく広げることができました。',
      ],
    },
    {
      type: 'sectionTitle',
      text: '継続して共に成長していきたいと思えるサービス',
    },

    {
      type: 'greyBox',
      texts: [
        'リニューアルを経て、共済マイページはユーザー数を大きく増やすことができ、地域の生協からもお客さまの声を多くフィードバックいただけるようになりました。',
        '自信を持っておすすめできるものを作れたと思っていますが、まだまだこの共済マイページを使いやすくしていきたいと思っていますし、「こんなことをしたい」という思いやアイデアがありますので、これからも継続してアップデートしていきたいと考えています。また、それと並行して、随時修正や改修作業も進めておりますが、アイスリーさんはデザインとコーディング両方を担当いただいていることもあって素早く対応していただけるので、とても感謝しています。',
        'この体制で今後もお客さまからの声に目を向けながら、みなさまのお役に立てるものを作っていきたいです。',
      ],
    },
  ],
]

const sectionTitle: { title: string; sub_title: string } = {
  title: 'Interview',
  sub_title: 'インタビュー',
}

const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>()
  const image = useRef<HTMLImageElement>()
  const text_container = useRef<HTMLDivElement>()
  // const container = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from(image.current, tweenVars, 0.2)
    timeline.from(text_container.current, tweenVars, 0.4)

    ScrollTrigger.create({
      animation: timeline,
      trigger: wrapper.current,
      start: 'top-=100 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
